import $ from 'jquery';

//add the antiforgery token to every request
$.ajaxSetup({
    beforeSend: function (xhr) {
        var tabcookie = getCookie(window.proxyxrf);
        if (!tabcookie) {
            tabcookie = "notfound"
        }
        var tabxsrf = $('#tab-xsrf').val();
        if (!tabxsrf) {
            tabxsrf = "notfound"
        }
        //only validate when both cookie and tabxsrf are found or else let it go.
        if (tabxsrf !== tabcookie) {
            window.location = "/RedirectBroker"
            return false;
        }
        xhr.setRequestHeader("RequestVerificationToken", $('#Token').val());
    }
});

//override the jquery post so we can adjust what we need for pure ajax calls. We don't plan on using www forms encoding right now.
$.post = function (url, data, headersToSet) {
    return jQuery.ajax({
        type: 'POST',
        url: _root + url,
        headers: headersToSet,
        contentType: "application/json",
        dataType: 'json',
        data: JSON.stringify(data)
    });
};

$.get = function (url, headersToSet, asyncCall) {
    return jQuery.ajax({
        type: 'GET',
        cache: false,
        headers: headersToSet,
        url: _root + url,
        contentType: "application/json",
        dataType: 'json',
        async: asyncCall == null ? true : false
    });
};

//url = string
//externalUrl = boolean. If this is an external web site pass in true. This means the url is an absolute url
$.delete = function (url, externalUrl) {

    let urlToSend = null;

    if (externalUrl == null || !externalUrl) {
        urlToSend = _root + url;
    }
    else {
        urlToSend = url;
    }

    return jQuery.ajax({
        type: 'DELETE',
        url: urlToSend,
        contentType: "application/json",
        dataType: 'json'
    });
};

$.fileUpload = function (url, parametersToSet, headers, progressCallBack) {

    //this is if you go straight to upload service. I don't think this is secure enough. I want to filter through the controller method even though we take on more memory
    var parameters = {
        url: url,
        method: "POST",
        data: parametersToSet,
        processData: false,
        contentType: false,
        beforeSend: function (xhr) {

            if (headers) {
                for (var i = 0; i < headers.length; i++) {
                    let item = headers[i];

                    xhr.setRequestHeader(item.key, item.value);
                }
            }
        }
    };

    //var parameters = {
    //    url: _root + 'api/Message/UploadTempFile?attachmentGroupId=' + attachmentGroupId,
    //    method: "POST",
    //    data: parametersToSet,
    //    processData: false,
    //    contentType: false,
    //    error: function (err) {
    //        errorHandler(err);
    //    }
    //};

    if (progressCallBack != null) {
        parameters.xhr = function () {
            var myXhr = $.ajaxSettings.xhr();
            if (myXhr.upload) { // check if upload property exists

                myXhr.upload.addEventListener('progress', progressCallBack, false); // for handling the progress of the upload
            }
            return myXhr;
        };
    }

    return $.ajax(parameters);
}

$.getHtml = function (url) {
    return jQuery.ajax(
        {
            url: _root + url,
            dataType: "html"
        });
}

function getCookie(name) {
    // Split cookie string and get all individual name=value pairs in an array
    var cookieArr = document.cookie.split(";");

    // Loop through the array elements
    for (var i = 0; i < cookieArr.length; i++) {
        var cookiePair = cookieArr[i].split("=");

        /* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
        if (name == cookiePair[0].trim()) {
            // Decode the cookie value and return
            return decodeURIComponent(cookiePair[1]);
        }
    }

    // Return null if not found
    return null;
}